import NProgress from "nprogress"; // progress bar
import "nprogress/nprogress.css"; // progress bar style

window.NProgress = NProgress;
